<template lang="html">
  <div class="user-profile" :class="theClass" @click="click">
    <v-row class="size-2">
      <v-col :md="4">
        <v-card class="p-3">
          <v-avatar
            :name="user.name"
            :about="user.profile + '<br>' + user.focus"
            :image="user.avatar_old"
            class="p-3"
          >
          </v-avatar>
          <v-button
            v-if="user.client && (user.client.email.includes('@vibbra') || [3120, 1659, 4168, 3848].includes(user.client.id))"
            class="block primary mt-3"
            :size="2"
            @click="selectVibbrante(user)"
            :disabled="isDisabled"
            >{{ buttonText }}</v-button
          >
          <v-button class="block gray mt-3" :size="2" @click="backSearch()"
            >Continuar buscando</v-button
          >
          <v-list class="user-profile mt-3">
            <v-text tag="div"
              ><b>Perfil público:</b>
              <span>
                <v-link :href="'#/profile/' + user.slug" target="_blank"
                  >Link</v-link
                >
                <v-helper
                  class="text-muted"
                  title="Perfil público"
                  placement="top"
                >
                  Link para acesso do perfil do profissional mesmo sem estar
                  logado na plataforma. Ideal para repassar para outras pessoas
                  interessadas em conhecer o profissional em questão. Basta
                  copiar a URL do navegador.
                </v-helper>
              </span>
            </v-text>
            <v-text tag="div"
              ><b>Experiência:</b>
              <span>{{ user.years_experience }} anos</span></v-text
            >
            <v-text
              v-if="
                user.profile === 'Desenvolvedor' &&
                  user.vibbrante_type == 'vibbrante'
              "
              tag="div"
              ><b>Qualidade de código:</b>
              <span>
                {{ user.code_quality }}
                <v-helper
                  class="text-muted"
                  title="Qualidade de código"
                  placement="top"
                >
                  Para os candidatos do perfil Desenvolvedor, realizamos uma
                  análise do código desenvolvido durante o seu teste técnico,
                  para verificar a qualidade. Fazemos essa análise através da
                  ferramenta CODACY, que gera uma nota de A até F. Apenas passam
                  e se tornam Vibbrantes aqueles profissionais que tiram A, B ou
                  C nessa avaliação.
                </v-helper>
              </span>
            </v-text>
            <v-text tag="div" v-if="user.profile === 'Designer'"
              ><b>Portfólio:</b>
              <v-link :href="user.portfolio.url" target="_blank"
                >Baixar</v-link
              ></v-text
            >
            <!-- <v-text tag="div"
              ><b>Valor/hora:</b>
              <span>{{ user.hour_value | currency }}</span></v-text
            > -->
            <v-text tag="div"
              ><b>Horas semanais livres:</b>
              <span>{{ user.hour_available }}h</span></v-text
            >
            <v-text tag="div"
              ><b>Horário comercial:</b>
              <span>{{ user.availability }}</span></v-text
            >
            <v-text tag="div"
              ><b>Inglês:</b> <span>{{ user.english_level }}</span></v-text
            >
            <v-text tag="div"
              ><b>Clientes estrangeiros:</b>
              <span v-if="user.exp_international_client === true">Sim</span>
              <span v-else>Não</span>
            </v-text>
            <v-text tag="div"
              ><b>Cidade:</b>
              <span>{{ user.city }}/{{ user.state }} </span></v-text
            >
            <v-text tag="div"
              ><b>Idade:</b> <span>{{ user.age }} anos</span></v-text
            >
            <v-text tag="div"
              ><b>Código do profissional:</b>
              <span>
                {{ user.id }}
                <v-helper
                  class="text-muted"
                  title="Código do profissional"
                  placement="top"
                >
                  Código utilizado para que consiga enontrar esse profissional
                  em específico na Busca. Para isso, basta acessar a tela de
                  Busca, no menu Profissionais > Buscar, abrir as Opções
                  Avançadas e inserir o código no campo "Código do
                  profissional", clicando em Filtrar.
                </v-helper>
              </span>
            </v-text>
          </v-list>
          <v-stars
            :stars="user.score"
            slot="top-right"
            v-if="user.vibbrante_type == 'vibbrante'"
          ></v-stars>
          <small
            slot="top-left"
            class="badge badge-success"
            v-if="user.vibbrante_type == 'vibbrante'"
            >{{ user.vibbrante_type }}!</small
          >
          <small
            slot="top-left"
            class="badge badge-light"
            v-if="user.vibbrante_type == 'freelancer'"
            >{{ user.vibbrante_type }}</small
          >
        </v-card>
      </v-col>
      <v-col :md="8">
        <v-card class="p-3">
          <v-tabs class="mb-3 nav-tabs">
            <v-button href="#tab-about" class="active">Sobre</v-button>
            <v-button href="#tab-skill">Habilidades</v-button>
            <v-button
              href="#tab-scores"
              v-if="user.vibbrante_type == 'vibbrante'"
              >Avaliação Vibbra</v-button
            >
          </v-tabs>
          <v-div class="tab-content">
            <v-content class="tab-pane fade" id="tab-skill" role="tabpanel">
              <v-text
                >Habilidades que o profissional possui experiência comprovada de
                mercado.</v-text
              >
              <v-row :size="2">
                <v-col :xs="12" v-for="skill in user.vibbrante_skills">
                  <v-text class="m-0">{{ skill.description }}</v-text>
                  <v-progress :percent="skill.score" />
                </v-col>
              </v-row>
            </v-content>
            <v-content
              class="mb-3 tab-pane show active"
              id="tab-about"
              role="tabpanel"
            >
              <v-text class="text-about">
                {{ user.about | trim }}
              </v-text>
              <v-divider line v-if="user.other_tags.length > 0" />
              <v-text v-if="user.other_tags.length > 0"
                >Tags relacionadas ao perfil do profissional.</v-text
              >
              <v-badge
                class="mr-2 mb-2 primary"
                v-for="t in user.other_tags"
                size="3"
                >{{ t }}</v-badge
              >
            </v-content>
            <v-content
              class="mb-3 tab-pane fade"
              id="tab-scores"
              role="tabpanel"
              v-if="user.vibbrante_type == 'vibbrante'"
            >
              <v-text
                >Resultado do Vibbrante no
                <v-link
                  href="http://vibbra.com.br/selecao_vibbra.pdf"
                  target="_blank"
                  >processo de seleção</v-link
                >
                da Vibbra</v-text
              >
              <v-row :size="2">
                <v-col :md="4">
                  <b>Avaliação Vibbra</b>
                </v-col>
                <v-col :md="8">
                  <v-stars class="mt-1" mode="number" :stars="user.score" />
                </v-col>
              </v-row>
              <hr />
              <v-row :size="2">
                <v-col :md="4">
                  Autogestão
                </v-col>
                <v-col :md="8">
                  <v-stars
                    class="mt-1"
                    mode="number"
                    :stars="user.score_self_management"
                  />
                </v-col>
              </v-row>
              <v-row :size="2">
                <v-col :md="4">
                  Comunicação
                </v-col>
                <v-col :md="8">
                  <v-stars
                    class="mt-1"
                    mode="number"
                    :stars="user.score_communication"
                  />
                </v-col>
              </v-row>
              <v-row :size="2">
                <v-col :md="4">
                  Experiência de mercado
                </v-col>
                <v-col :md="8">
                  <v-stars
                    class="mt-1"
                    mode="number"
                    :stars="user.score_experience"
                  />
                </v-col>
              </v-row>
              <v-row :size="2">
                <v-col :md="4">
                  Qualidade técnica
                </v-col>
                <v-col :md="8">
                  <v-stars
                    class="mt-1"
                    mode="number"
                    :stars="user.score_technical_quality"
                  />
                </v-col>
              </v-row>
              <v-row :size="2">
                <v-col :md="4">
                  Trabalho remoto
                </v-col>
                <v-col :md="8">
                  <v-stars
                    class="mt-1"
                    mode="number"
                    :stars="user.score_remote_work"
                  />
                </v-col>
              </v-row>
            </v-content>
            <v-content class="tab-pane fade" id="tab-feedback" role="tabpanel">
              <v-text
                >Feedbacks recebidos de contratantes na plataforma.</v-text
              >
              <v-col :xs="12" v-for="feedback in user.feedbacks">
                <hr />
                <v-row :size="2">
                  <v-col :md="12">
                    <v-text class="m-0"
                      ><b
                        >Contratante {{ feedback.client }} - Consumo de
                        {{ feedback.total_hours }} horas</b
                      ></v-text
                    >
                  </v-col>
                </v-row>
                <v-row :size="2">
                  <v-col :md="5">
                    <v-text class="m-0">Qualidade técnica</v-text>
                  </v-col>
                  <v-col :md="7">
                    <v-stars
                      class="mt-1"
                      mode="full"
                      :stars="feedback.rating_quality"
                    />
                  </v-col>
                </v-row>
                <v-row :size="2">
                  <v-col :md="5">
                    <v-text class="m-0">Profissionalismo</v-text>
                  </v-col>
                  <v-col :md="7">
                    <v-stars
                      class="mt-1"
                      mode="full"
                      :stars="feedback.rating_professionalism"
                    />
                  </v-col>
                </v-row>
                <v-row :size="2">
                  <v-col :md="5">
                    <v-text class="m-0">Contrataria novamente</v-text>
                  </v-col>
                  <v-col :md="7">
                    <v-stars
                      class="mt-1"
                      mode="full"
                      :stars="feedback.rating_recommendation"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-content>
          </v-div>
        </v-card>
      </v-col>
    </v-row>
    <v-confirm-modal
      name="confirm-selected-vibbrante"
      :show="showConfirmModal"
      @onHide="showConfirmModal = false"
      @onGoSelectedVibbrantes="goToSelecteds()"
    />
  </div>
</template>

<script>
import config from '../../configs/js/config';

import FilterBar from './filter-bar';
import ConfirmModal from '../modals/confirm-selected-vibbrante';

export default {
  components: {
    'v-filter-bar': FilterBar,
    'v-confirm-modal': ConfirmModal,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      showConfirmModal: false,
      buttonText: 'Selecionar profissional',
    };
  },
  methods: {
    click() {
      this.$emit('click');
    },
    goToVibbrant() {},
    goToSelecteds() {
      setTimeout(() => {
        this.$router.push({ name: 'client-search-request' });
      }, 200);
    },
    selectVibbrante(data) {
      this.$store.dispatch('addSelVibbranteDirect', data);
      this.buttonText = 'Selecionado';
      this.isDisabled = true;
      this.showConfirmModal = true;
    },
    backSearch() {
      this.$router.push({ name: 'client-search' });
    },
  },
  computed: {
    theClass() {
      return 'type-';
    },
    isDisabled() {
      console.log(this.user);
      for (
        let i = 0;
        i < this.$store.getters.selected_vibbrantes.length;
        i += 1
      ) {
        if (this.$store.getters.selected_vibbrantes[i].id === this.user.id) {
          this.buttonText = 'Selecionado';
          return true;
        }
      }
      this.buttonText = 'Selecionar profissional';
      return false;
    },
  },
};
</script>

<style lang="scss">
.continue-search {
  text-align: right;
}
.user-profile {
  .user-row-info {
    .col {
      text-align: center;
      background-color: gray(100);
      div.text {
        font-size: 1.4em;
      }
      small.text {
        line-height: 1em;
        font-size: 0.8em;
        display: block;
      }
    }
  }
  .profile-bg {
    height: 130px;
    background: gray(200);
    margin-bottom: -90px;
  }
  .avatar .avatar-image {
    width: 100px;
  }
  .user-about {
    padding: 1em;
  }
  .text-about {
    white-space: pre-wrap;
  }
  @each $profile in $profiles {
    &.type-#{$profile} {
      .profile-bg {
        background-color: color($profile);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/modules/vibbrant-profile-full.vue